var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Expose } from 'class-transformer';
import { EBookSheetType } from '~/shared/types/book-sheet';
export class ModelBookSheet {
    albumId;
    cdate;
    enableRedirection;
    fperiod;
    id;
    isSyncable;
    mdate;
    order;
    ownerId;
    parentId;
    redirectLink;
    relativeId;
    speriod;
    title;
    type;
}
__decorate([
    Expose({ name: 'album_id' }),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "albumId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "cdate", void 0);
__decorate([
    Expose({ name: 'enable_redirection' }),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "enableRedirection", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBookSheet.prototype, "fperiod", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "id", void 0);
__decorate([
    Expose({ name: 'is_syncable' }),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "isSyncable", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "mdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "order", void 0);
__decorate([
    Expose({ name: 'owner_id' }),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "ownerId", void 0);
__decorate([
    Expose({ name: 'parent_id' }),
    __metadata("design:type", Object)
], ModelBookSheet.prototype, "parentId", void 0);
__decorate([
    Expose({ name: 'redirect_link' }),
    __metadata("design:type", Object)
], ModelBookSheet.prototype, "redirectLink", void 0);
__decorate([
    Expose({ name: 'relative_id' }),
    __metadata("design:type", Object)
], ModelBookSheet.prototype, "relativeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBookSheet.prototype, "speriod", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookSheet.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_a = typeof EBookSheetType !== "undefined" && EBookSheetType) === "function" ? _a : Object)
], ModelBookSheet.prototype, "type", void 0);
